<template>
  <InternalTransferDataTable></InternalTransferDataTable>
</template>

<script>
import InternalTransferDataTable from './InternalTransferDataTable.vue';


export default {
  components: { InternalTransferDataTable },
};
</script>